/**
 * Audit stamp expected by the trialing APIs: the creating user on the initial
 * POST, and the last editing user on every subsequent PATCH.
 *
 * @param method The HTTP method the payload is being sent with.
 * @param userId Id of the logged-in user (`user.id` from `useAuth`).
 * @returns The audit field to spread into the request payload, or an empty
 * object when the user id isn't available yet -- so a null id is never sent.
 */
export const getAuditFields = (
  method: "post" | "patch",
  userId?: string | null
): Record<string, string> => {
  if (!userId) return {};
  return method === "post" ? { created_by: userId } : { updated_by: userId };
};
